import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import globals from './globals.js'
import mailForm from './mail_form.js'
import analytics from './libs/viewers.js'

const levelMenu = {}

let menuClickDisabled = false
let currentLevelID


eventBus.on('levels loaded', init)

eventBus.on('current state loaded', displayCurrentState)


let levels


//******************************** INIT

function init (newLevels) {

    levels = newLevels


    $('#show_menu').click(function () {
        analytics.emit('clickMenu')
        eventBus.emit('menu displayed')
        show()
    })


    $('#levels, #mask').click(function () {
        if (!mailForm.displayed) {
            close()
        }
    })

    addLevelMarks()

    listenToLevelChoice()

    $(window).on('resize', position)

}


function addLevelMarks () {
    const container = $('#levels')
    const devMode = (window.location.hostname === 'localhost')

    levels.forEach(({id}) => {
        container.append(
            '<div class="level" id="level_' + id + '" data-level="' + id + '">' +
            (devMode ? '<div class="name">' + (id.replace('_', ' ')) + '</div>' : '') +
            '</div>'
        )
    })

    // FIXME $('#level_' + levels.length).addClass('end_status')
}


function displayCurrentState (levelID, parkour) {
    setCurrentLevelID(levelID)

    for (let id in parkour.doneSteps) {
        $('#level_' + id).addClass('done')
    }

    checkMenuIconVisibility(levelID, parkour)


    $('#level_' + currentLevelID).addClass('current_level')
}






//******************************** LEVEL CHOICE AND CURRENT LEVEL

eventBus.on('level changed', setCurrentLevelID)

eventBus.on('level won', markDoneLevel)




function setCurrentLevelID (levelID) {
    currentLevelID = levelID
}


function markDoneLevel (levelID) {
    $('#level_' + levelID).addClass('done')
}


function animateCurrentLevel (callback) {

    $('.level').removeClass('current_level')
    const $currentLevel = $('#level_' + currentLevelID)

    $currentLevel.addClass('current_level')
    setTimeout(function () {
        $currentLevel.css('visibility', 'visible').hide().fadeIn(500, callback)
    }, 500)

}



function listenToLevelChoice () {
    $('.level').not('.end_status').click(function (e) {
        e.stopImmediatePropagation()
        if (menuClickDisabled) {
            return
        }
        globals.currentChallenge.destroy()
        $('#challenges_container').html('')

        const selectedLevel = $(e.currentTarget).data('level')
        eventBus.emit('user wants to go to level', selectedLevel)
        animateCurrentLevel(close)
    })
}










//******************************** SHOW AND HIDE


levelMenu.showAndUpdate = function (afterUpdate) {
    menuClickDisabled = true
    show(function () {
        animateCurrentLevel()
        if (afterUpdate) {
            closeSoon(afterUpdate)
        } else {
            menuClickDisabled = false
        }
    })
}



function show (callback) {

    if (globals.currentChallenge) {
        globals.currentChallenge.pause()
    }

    position()

    document.activeElement.blur()   // closes the virtual keyboard, over the menu otherwise
    $('body').addClass('menu_shown')
    $('.blur_on_menu').addClass('blurry')

    $('#mask').fadeIn(250)

    $('#levels').delay(250).fadeIn(500, callback)

}


function closeSoon (callback) {
    setTimeout(function () {
        close(callback)
        menuClickDisabled = false
    }, 1900)

}



function close (callback) {
    $('#mask').fadeOut(100, function () {
        $('body').removeClass('menu_shown')
        $('.blur_on_menu').removeClass('blurry')
    })

    $('#levels').fadeOut(300, function () {
        if (globals.currentChallenge) {
            globals.currentChallenge.unPause()
            globals.currentChallenge.focus()
        }
        if (callback) {
            callback()
        }
    })

    eventBus.emit('menu hidden')
}





//******************************** MENU ICON


eventBus.on('level changed', checkMenuIconVisibility)

eventBus.on('level won', checkMenuIconVisibility)


function checkMenuIconVisibility (levelId, parkour) {
    if (parkour.doneStepsCount >= Math.min(0, levels.length - 1)) { //FIXME was min(2, ...)
        $('#show_menu').show()
    }
}





//******************************** END HANDLING


eventBus.on('already ended on start', alreadyEndedOnStart)

eventBus.on('end', function () {
    recordEndStatus()
    show(function () {
        animateCurrentLevel(addEndMessage)
    })
})



let gameEnded = false

function recordEndStatus () {
    gameEnded = true
}



function addEndMessage () {
    $('#levels .end').fadeIn(800)
}


function alreadyEndedOnStart () {
    recordEndStatus()
    $('.end_status').addClass('done')
    addEndMessage()
}




//******************************** POSITION AND GEOMETRY

const idealTotalTurns  = 2.25
const maxLevelsPerTurn = 12.5
const minLevelsPerTurn = 8

const endAngle         = 0


function position () {

    const center = positionMenuContainer()

    const radiusFunction = getRadiusFunction(center)

    const deltaAngle = -2 * Math.PI * clamp(
        idealTotalTurns / (levels.length - 1),
        1 / maxLevelsPerTurn,
        1 / minLevelsPerTurn
    )
    const startAngle = endAngle - (levels.length - 1) * deltaAngle

    for (let i = levels.length - 1; i >= 0; i--) {
        const angle = startAngle + i * deltaAngle
        positionLevelMark(levels[i].id, angle, radiusFunction(i), center)
    }
}


function positionMenuContainer () {
    const screenWidth  = $(window).width()
    const screenHeight = $(window).height()

    $('#levels').css({
        width:  screenWidth  + 'px',
        height: screenHeight + 'px'
    })

    return {
        x: 0.5 * screenWidth,
        y: 0.5 * (screenHeight - (gameEnded ? 80 : 0))
    }
}


function positionLevelMark (id, angle, radius, center) {
    const levelRadius = radius * 0.18

    $('#level_' + id).css({
        top:    (center.y - levelRadius - Math.sin(angle) * (radius - levelRadius)) + 'px',
        left:   (center.x - levelRadius + Math.cos(angle) * (radius - levelRadius)) + 'px',
        width:  levelRadius * 2,
        height: levelRadius * 2,
        fontSize: (levelRadius * 0.6) + 'px'
    })
}


function getRadiusFunction (center) {
    const stepsCount = levels.length

    const maxRadius = Math.min(center.x, center.y) * smoothstep(0.6, 0.9, (stepsCount - 1) / 12)
    const minRadius = maxRadius * 0.2
    const radiusMultiplier = 1 / Math.pow(maxRadius / minRadius, 1 / stepsCount)

    return function (i) {
        return Math.pow(radiusMultiplier, stepsCount - 1 - i) * maxRadius
    }
}




function clamp (value, min, max) {
    return Math.min(Math.max(min, value), max)
}


function smoothstep (a, b, x) {
    x = clamp(x, 0, 1)
    const step = x * x * (3 - 2 * x)
    return a + step * (b - a)
}


export default levelMenu

